const u = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

export const IMAGES = {
  cityRail: u("photo-1596796679119-7cf1a9e5448b"),
  citySunset: u("photo-1459787827056-fca21e4b5b17"),
  cityPlatform: u("photo-1610696995907-f943789a9125"),
  labLaptop: u("photo-1581093577421-f561a654a353"),
  labMicroscope: u("photo-1582719471384-894fbb16e074"),
  labDish: u("photo-1486825586573-7131f7991bdd"),
  labPipette: u("photo-1614935151651-0bea6508db6b"),
  lake: u("photo-1685271567156-4fc3e4847783"),
  lakeBoat: "https://images.pexels.com/photos/12290392/pexels-photo-12290392.jpeg?auto=compress&cs=tinysrgb&w=1200",
  stage: u("photo-1587825140708-dfaf72ae4b04"),
  audience: u("photo-1540575467063-178a50c2df87"),
};

export const NAV = [
  { to: "/about", key: "nav.about", id: "about" },
  { to: "/research", key: "nav.stories", id: "research" },
  { to: "/events", key: "nav.events", id: "events" },
  { to: "/repository", key: "nav.repository", id: "repository" },
  { to: "/contact", key: "nav.contact", id: "contact" },
];
export const EVENT_FILTERS = {
  mode: ["Online", "In-person", "Hybrid"],
  fee: ["Free", "Paid"],
  mood: ["Formal", "Casual"],
};
